<template>
  <div
    class="arrow-breadcrumb"
    @click="handleClick"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div :class="['shadow-box', isHovered && 'shadow-box-hover']"></div>
    <div class="arrow-background">
      <arrow-left-rounded
        v-if="rounded"
        class="arrow-left"
        :hovered="isHovered"
      />
      <arrow-left
        v-else
        class="arrow-left"
        :hovered="isHovered"
      />
      <arrow-center class="arrow-center" />
      <arrow-right
        class="arrow-right"
        :hovered="isHovered"
      />
    </div>
    <div class="breadcrumb-content flex gap-2 items-center">
      {{ breadcrumb.label }}
      <ic-info-solid
        v-if="breadcrumb.anomaly"
        :class="['transform rotate-180', breadcrumb.anomaly]"
        size="18"
      />
    </div>
  </div>
</template>

<script>
import ArrowLeft from './arrow-left.vue'
import ArrowLeftRounded from './arrow-left-rounded.vue'
import ArrowCenter from './arrow-center.vue'
import ArrowRight from './arrow-right.vue'
import IcInfoSolid from '@/components/icon/brightbid/ic-info-solid.vue'

export default {
  name: 'ArrowBreadcrumb',
  components: {
    ArrowLeft,
    ArrowLeftRounded,
    ArrowCenter,
    ArrowRight,
    IcInfoSolid,
  },
  props: {
    breadcrumb: {
      type: Object,
      required: true,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHovered: false,
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.breadcrumb)
    },
  },
}
</script>

<style lang="scss" scoped>
.arrow-breadcrumb {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 38px;
  cursor: pointer;
  white-space: nowrap;
}

.shadow-box {
  position: absolute;
  top: 0;
  left: 16px;
  right: 16px;
  height: 36px;
  margin-top: 1px;
  pointer-events: none;
  z-index: 0;
  transition: box-shadow 0.3s ease;
}

.shadow-box-hover {
  box-shadow: 0px 2px 14px 0px rgba(136, 152, 170, 0.15);
}

.arrow-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  pointer-events: none;
}

.arrow-left {
  flex: 0 0 auto;
  width: 16px;
  transition: filter 0.2s ease;
}

.arrow-center {
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
  transition: filter 0.2s ease;
}

.arrow-right {
  flex: 0 0 auto;
  width: 16px;
  transition: filter 0.2s ease;
}

.breadcrumb-content {
  position: relative;
  z-index: 1;
  padding: 0 1.5rem;
}
</style>
